(function () {
  angular.module('MktzapApp.Controllers')
    .controller('CpSettingsController', cpSettings);

  cpSettings.$inject = ['$rootScope', 'StatusService', 'NotificationService', 'CompanyService', 'FoundationApi'];

  function cpSettings ($rootScope, StatusService, NotificationService, CompanyService, FoundationApi) {
    var vmCpSettingsCtrl = this;

    vmCpSettingsCtrl.loadMetadata = function () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vmCpSettingsCtrl.metadata = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Algo deu errado ao carregar metadados. Consulte o suporte.');
        });
    };

    vmCpSettingsCtrl.loadShouldCloseStatuses = function () {
      StatusService
        .should_close_statuses()
        .$promise
        .then(function (data) {
          vmCpSettingsCtrl.shouldCloseStatus = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar status');
        });
    }

    vmCpSettingsCtrl.saveMetadata = function () {
      CompanyService
        .saveMetadata(vmCpSettingsCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, 'Configuração salva com sucesso.');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao salvar configuração.');
        });
    }

    vmCpSettingsCtrl.trackerAllowMessage = function () {
      if (vmCpSettingsCtrl.metadata.track_notification_configs.allow_message) {
        vmCpSettingsCtrl.metadata.track_notification_configs.allow_message = true;
      } else {
        vmCpSettingsCtrl.metadata.track_notification_configs.message = null;
        vmCpSettingsCtrl.saveMetadata();
      }
    }

    vmCpSettingsCtrl.trackerAllowStatus = function () {
      if (vmCpSettingsCtrl.metadata.track_notification_configs.allow_status) {
        vmCpSettingsCtrl.metadata.track_notification_configs.allow_status = true;
      } else {
        vmCpSettingsCtrl.metadata.track_notification_configs.status = null;
        vmCpSettingsCtrl.saveMetadata();
      }
    }

    vmCpSettingsCtrl.trackerSaveMessage = function () {
      if (!vmCpSettingsCtrl.metadata.track_notification_configs.message) {
        NotificationService.warningHandler(null, 'Mensagem obrigatória');
        return;
      }
      vmCpSettingsCtrl.saveMetadata();
    }

    vmCpSettingsCtrl.trackerSaveStatus = function () {
      if (!vmCpSettingsCtrl.metadata.track_notification_configs.status) {
        NotificationService.warningHandler(null, 'Status obrigatório');
        return;
      }
      vmCpSettingsCtrl.saveMetadata();
    }

    vmCpSettingsCtrl.loadMetadata();
    vmCpSettingsCtrl.loadShouldCloseStatuses();
  }
})();
